import React from 'react';

const ApplicationCard = ({applicationFee}) => {
    return (
        <div className="card-container application-card">
            <div className="card-title-section">
                <span>Application Fee</span>
            </div>
            <div className="card-content-section">
                <span>{applicationFee}</span>
            </div>
        </div>
    );
};

export default ApplicationCard;
